export default {"gitHash":"53eb6d4917b7cdda80dd6257256a8a992bc478b5","gitHashShort":"53eb6d4","time":1644844143880,"platform":"linux","arch":"x64"};